module.exports = __webpack_public_path__ + "img/bg4.8b954299.png";